import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import { Line } from "react-chartjs-2";
import { useMemo } from "react";
import { LocaleContext } from "../../contexts/LocaleContext";
import { useContext } from "react";

// Register Chart.js components
ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);

export default function MonthlyNewUsers({
  title = "",
  monthlyNewUser,
  height = 300,
  showLegend = true,
}) {
    const { t } = useContext(LocaleContext);
    const labels = ["Jan", "Feb", "Mar", "Apr", "May","Jun", "Jul","Aug","Sep","Oct","Nov","Dec"];

  const datasets = [
    {
      data: monthlyNewUser?.users || [0, 0, 0, 0, 0,0, 0,0,0,0,0,0],
      borderColor: "rgb(53, 162, 235)",
      backgroundColor: "rgba(53, 162, 235, 0.3)",
      tension: 0.4, // smooth curve
    }
  ];
  // Memoized data for performance
  const data = useMemo(() => {
    return {
      labels,
      datasets,
    };
  }, [labels, datasets]);

  // Memoized options
  const options = useMemo(() => {
    return {
      responsive: true,
      maintainAspectRatio: false,
      plugins: {
        legend: {
          display: showLegend,
          position: "top",
          display: false,
        },
        title: {
          display: !!title,
          text: title,
        },
        tooltip: {
          enabled: true,
        },
      },
      scales: {
        x: {
          grid: {
            display: false,
          },
        },
        y: {
          beginAtZero: true, // you can set true for all positive numbers
          ticks: {
            precision: 0,
            callback: (value) => Number(value).toFixed(0),
          },
        },
      },
    };
  }, [title, showLegend]);

  // Empty state handling
  if (!labels.length || !datasets.length) {
    return <p style={{ textAlign: "center" }}>No data available</p>;
  }

  return (
    <div style={{ height }}>
      <Line data={data} options={options} />
    </div>
  );
}